import { Card, CardContent, CardMedia } from '@mui/material'
import React, { ComponentPropsWithoutRef, useCallback, useState } from 'react'
import placeholder from '../../../../assets/video_placeholder.png'

interface ContentCardImageProps extends ComponentPropsWithoutRef<'div'> {
  image?: JSX.Element | string
}
export function EmbedCard({ children, image, ...props }: ContentCardImageProps) {
  const [hoverState, setHoverState] = useState<boolean>(false)
  const source:any = image || placeholder
  // const RenderImage = useCallback(() => {
  //   if (!image || typeof image === 'string') {
  //     const imageRoute = image || placeholder
  //     return <CardMedia component="img" image={imageRoute} alt="card image" sx={{ 'height': 200, ':hover': { 'cursor': 'pointer' } }} />
  //   }
  //   return image
  // }, [image])

  return (
    <Card className="p-4" elevation={hoverState ? 10 : 1} onMouseOver={() => setHoverState(true)} onMouseLeave={() => setHoverState(false)} {...props}>
      {/* <RenderImage /> */}
      <img className="w-[100px] rounded" src={source} alt={"embed image"}/>
      <CardContent sx={{ paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px !important' }}>{children}</CardContent>
    </Card>
  )
}

EmbedCard.defaultProps = {
  image: '',
}
